import { Component, OnInit } from '@angular/core';

import { LoginService, CountriesService, routeActivationEndData$, RouteData } from '@whitehatgaming/shared';
import { CookieService } from 'ngx-cookie-service';

import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Country } from '@whitehatgaming/shared/lib/services/lists.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public loggedIn: boolean = false;
  public headerVisible$: Observable<boolean>;
  public storedTheme: string = localStorage.getItem('theme-color');
  public message: string;
  public cookieValue: string;
  public country: string;

  public footerVisible$: Observable<boolean>;

  constructor(
    private login: LoginService,
    private countries: CountriesService,
    private cookieService: CookieService,
    private router: Router
  ) {
    this.loggedIn = this.login.loggedIn;

    this.countries.getCountry().subscribe((data: Country) => {
      this.country = data.value.toLowerCase();
    });
  }

  public get isOntario(): boolean {
    return !!sessionStorage.getItem('jurisdiction') && sessionStorage.getItem('jurisdiction') === 'CA-ONT';
  }

  public ngOnInit(): void {
    this.headerVisible$ = routeActivationEndData$(this.router).pipe(
      map((data: RouteData) => !(data?.appHeaderHidden || data?.pnpQuickDepositEnabled))
    );

    this.footerVisible$ = combineLatest(routeActivationEndData$(this.router), this.countries.getCountry()).pipe(
      map(([data, country]: [RouteData, Country]): boolean => {
        if (country.value !== 'DE') {
          return false;
        }

        return !(data?.appHeaderHidden || data?.pnpQuickDepositEnabled);
      })
    );

    this.checkCookieTheme();
  }

  public checkCookieTheme(): void {
    const container: Element = document.getElementsByClassName('content')[0];

    this.cookieValue = this.cookieService.get('theme');

    if (this.cookieValue === 'dark') {
      container.classList.add('theme-dark');
      localStorage.setItem('theme-color', 'theme-dark');
    } else {
      container.classList.add('theme-light');
      localStorage.setItem('theme-color', 'theme-light');
    }
  }
}
